import styled from 'styled-components'

export const StyledTopImage = styled.div`
  width: 100%;
  height: calc(100vh - 7rem);
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
